import pl1 from "./playlists/pl1.js";
import pl2 from "./playlists/pl2.js";
import a_t2 from "./alex_tren/a_t2.js";
import a_t4 from "./alex_tren/a_t4.js";
import a_t7 from "./alex_tren/a_t7.js";
import a_t9 from "./alex_tren/a_t9.js";
import a_t10 from "./alex_tren/a_t10.js";
import a_t12_1 from "./alex_tren/a_t12_1.js";
import a_t12_2 from "./alex_tren/a_t12_2.js";
import a_t14_1 from "./alex_tren/a_t14_1.js";
import a_t18_1 from "./alex_tren/a_t18_1.js";
import a_t16_1 from "./alex_tren/a_t16_1.js";
import a_t15_1 from "./alex_tren/a_t15_1.js";
import a_t15_2 from "./alex_tren/a_t15_2.js";
import a_ir1 from "./alex_tren/txteng13.js";
import a_fv1 from "./alex_tren/txteng14.js";
import a_fv2 from "./alex_tren/txteng15.js";
import ameng_get1 from "./amer_eng/txteng16.js";
import ameng_get2 from "./amer_eng/txteng17.js";
import ameng_get3 from "./amer_eng/txteng18.js";
import ameng_get4 from "./amer_eng/txteng19.js";
import ameng1 from "./amer_eng/t1.js";
import song1 from "./songs/song1.js";
import song2 from "./songs/song2.js";
import song3 from "./songs/song3.js";
import song4 from "./songs/song4.js";
import s_s10 from "./sunshine/s10.js";
import s_s11 from "./sunshine/s11.js";
import s_c01 from "./sunshine/cruel1.js";
import jes1 from "./jes/jes1.js";

const txts = [
  { arr: pl1, descr: "phrases a1-1" },
  { arr: pl2, descr: "phrases a1-2" },
  { arr: a_t2, descr: "I am (t2)" },
  { arr: a_t4, descr: "Am I? (t4)" },
  { arr: a_t7, descr: "Why you? (t7)" },
  { arr: a_t9, descr: "why am (cont) (t9)" },
  { arr: a_t10, descr: "present simple (t10)" },
  { arr: a_t12_1, descr: "why do you (t12-1)" },
  { arr: a_t12_2, descr: "why do you (t12-2)" },
  { arr: a_t14_1, descr: "present simple-cont (t14-1)" },
  { arr: a_t15_1, descr: "past (t15-1)" },
  { arr: a_t15_2, descr: "past (t15-2)" },
  { arr: a_t16_1, descr: "past (t16-1)" },
  { arr: a_t18_1, descr: "past-present (t18-1)" },
  { arr: s_s10, descr: "sun selfish 10" },
  { arr: s_s11, descr: "sun selfish 11" },
  { arr: s_c01, descr: "sun cruel 1" },
  { arr: a_ir1, descr: "Irregular" },
  { arr: a_fv1, descr: "frase verbs get" },
  { arr: a_fv2, descr: "frase verbs" },
  { arr: ameng_get1, descr: "get 1" },
  { arr: ameng_get2, descr: "get 2" },
  { arr: ameng_get3, descr: "get 3" },
  { arr: ameng_get4, descr: "get 4" },
  { arr: ameng1, descr: "money" },
  { arr: jes1, descr: "jes1" },
  { arr: song1, descr: "Blind man" },
  { arr: song2, descr: "Sail awai" },
  { arr: song3, descr: "Child in time" },
  { arr: song4, descr: "Anya" },
];

export default txts;
